import createAxiosLogin from './axiosLogin';
import createAxios from './axiosHttp';


export const userService = {
  login,
  changePassword,
  tieneRol,
  logout,
  getUsers,
  newUser,
  deleteUser,
  userStatus
};

function login(user, password) {
  const axios = createAxiosLogin();
  return axios.post('/auth/login', { user, password }).then((userLogged) => {
    if (userLogged) {
      localStorage.setItem('user', JSON.stringify(userLogged));
    }
    return userLogged;
  });
}

function logout() {
  localStorage.removeItem('user');
}
function tieneRol(user, rol) {
  return user.roles != null && user.roles.indexOf(rol) > -1;
}

function newUser(tipo, id, user) {
  const axios = createAxios();
  let urlPath = `/${tipo}/${id}/auth/user`;
  return axios.post(urlPath, user);
}

function changePassword(body) {
  const axios = createAxios();
  const urlPath = '/auth/password';
  return axios.post(urlPath, body);
}

function deleteUser(userId) {
  const axios = createAxios();
  const urlPath = `/auth/user/${userId}/delete`;
  return axios.delete(urlPath);
}

function userStatus(body, userId){
  const axios = createAxios();
  let urlPath = `/auth/user/${userId}`;
  return axios.put(urlPath, body);
}

function getUsers(filters, pagination) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/customer/${user.extraData.customerId}/auth/user`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
  } else {
    urlPath += '?page=0';
  }

  if (filters && filters.search) {
    urlPath += `&search=${encodeURIComponent(filters.search)}`;
  }
  if (filters && filters.status) {
    urlPath += `&status=${filters.status}`;
  }

  if (filters && filters.sort) {
    if(filters.sort.sort){
        urlPath += `&sort=${filters.sort.sort}`;
    }
    if(filters.sort.order){
        urlPath += `&order=${filters.sort.order}`;
    }
  }
  return axios.get(urlPath);
}


